var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.shouldShowPagination)?_c('v-pagination',{attrs:{"length":_setup.paginationComponentLength,"total-visible":"10","value":_vm.currentPage,"circle":""},on:{"input":function($event){return _vm.$emit('paginationClicked', $event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }